export const ORDER_GET_REQUEST = "ORDER_GET_REQUEST";
export const ORDER_GET_SUCCESS = "ORDER_GET_SUCCESS";
export const ORDER_GET_FAILED = "ORDER_GET_FAILED";


export const ORDER_DELETE_SUCCESS = "ORDER_DELETE_SUCCESS";